import {
  IImageResponseQuestionModelState,
  IImageResponseResponseValidation,
  ImageResponseQuestionModelTypes
} from './types'
import { IQuestionModelConstructor, QuestionType } from '../types'
import BaseQuestionModel from '../BaseQuestionModel'

const ImageResponseQuestionModel: IQuestionModelConstructor<ImageResponseQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const text = questionSchema.text

  if (text.includes('[[AllowAnyFileType]]')) {
    questionSchema.text = text.replace('[[AllowAnyFileType]]', '')
    questionSchema.any_file = true
  }

  const { model } = BaseQuestionModel<ImageResponseQuestionModelTypes, IImageResponseQuestionModelState>({
    questionType: QuestionType.IMAGE_RESPONSE,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response, questionSchema }: IImageResponseQuestionModelState) {
  return response.c
    ? [
        {
          id: questionSchema.id,
          uid: response.uid,
          c: response.c
        }
      ]
    : response.uid || !questionSchema.optional
    ? [
        {
          id: questionSchema.id,
          uid: response.uid
        }
      ]
    : [{ id: questionSchema.id }]
}

function initState(state: IImageResponseQuestionModelState): IImageResponseQuestionModelState {
  state.response = { uid: null }
  return state
}

function validateResponse({
  response,
  questionSchema
}: IImageResponseQuestionModelState): IImageResponseResponseValidation {
  if (response.uid || questionSchema.optional)
    return {
      valid: true
    }

  return {
    valid: false
  }
}

export default ImageResponseQuestionModel
